import { ComponentType, FC, SVGAttributes } from 'react';

import DefectBeperktInzetbaarXs from '@/assets/icons/DefectBeperktInzetbaarXs';
import DefectInzetbaarXs from '@/assets/icons/DefectInzetbaarXs';
import DefectNietInzetbaarXs from '@/assets/icons/DefectNietInzetbaarXs';
import DefectZandloper from '@/assets/icons/DefectZandloper';
import DefectZandloperXl from '@/assets/icons/DefectZandloperXl';

import styles from './Defect.module.css';

const defectSoortIconMap: Record<string, ComponentType<SVGAttributes<SVGSVGElement>>> = {
  DefectNietInzetbaarXs,
  DefectBeperktInzetbaarXs,
  DefectInzetbaarXs,
};

/** The defect zandloper icon. provide 'xl' to get the XL Zandloper variant used in the sidepanel.
 *
 * @param ComponentProps<typeof Icon>
 * @returns
 */
const DefectZandloperIcon: FC<SVGAttributes<SVGSVGElement> & { xl?: boolean }> = ({ xl = false, ...iconProps }) => {
  return xl ? (
    <DefectZandloperXl
      aria-hidden='true'
      width='24px'
      height='24px'
      className={styles.ZandloperIconXlStyle}
      {...iconProps}
    />
  ) : (
    <DefectZandloper
      aria-hidden='true'
      width='16px'
      height='16px'
      className={styles.ZandloperIconStyle}
      {...iconProps}
    />
  );
};

/** Get the icon name of the mapped defect.soort.
 *
 * @param defectSoort
 * @returns
 */
const defectSoortIcon = (defectSoort: string) => {
  const soortIcon = {
    DEFECT_NIET_INZETBAAR: 'DefectNietInzetbaarXs', // blauw
    BEPERKING_IN_TREINDIENST: 'DefectBeperktInzetbaarXs', // rood
    GEEN_BEPERKINGEN: 'DefectInzetbaarXs', // grijs
  };
  return soortIcon?.[defectSoort] ?? 'DefectInzetbaarXs';
};

type DefectIconType = SVGAttributes<SVGSVGElement> & {
  defectSoort: 'BEPERKING_IN_TREINDIENST' | 'DEFECT_NIET_INZETBAAR' | 'GEEN_BEPERKINGEN';
  nietInzetbaarBinnen24Uur?: boolean;
};
const DefectIcon: FC<DefectIconType> = ({ defectSoort, nietInzetbaarBinnen24Uur = false, ...iconProps }) => {
  const iconName = defectSoortIcon(defectSoort);
  const DefectIconComp = defectSoortIconMap[iconName];
  return (
    <div className={styles.defectIconsRowStyle}>
      {DefectIconComp && (
        <DefectIconComp
          className={styles[`ddpDefectIconStyleVariants__${defectSoort}`]}
          aria-hidden='true'
          width='16px'
          height='16px'
          {...iconProps}
        />
      )}
      {nietInzetbaarBinnen24Uur && defectSoort !== 'DEFECT_NIET_INZETBAAR' && <DefectZandloperIcon />}
    </div>
  );
};
export default Object.assign(DefectIcon, {
  Zandloper: DefectZandloperIcon,
});
